import React from 'react';
import { observer } from 'mobx-react';
import { BaasicErrorModalTemplate } from 'themes/components';

function BaasicErrorModal(props) {
	return <BaasicErrorModalTemplate {...props} />;
}

export default observer(BaasicErrorModal);



// WEBPACK FOOTER //
// ./src/core/components/dialog/BaasicErrorModal.jsx